import React from 'react'

const Play = () => {
  return (
    <div className='flex min-h-screen justify-center items-center'>
      <h1>TEST</h1>
    </div>
  )
}

export default Play
